module.exports = __webpack_public_path__ + "fonts/icomoon-bold.e97c100.ttf";